// Help modal — first preact component (phase 3 starter).
// Pure static text, no game state. The "open" state is local to the
// component; openHelp() / closeHelp() are exported so vanilla code
// (main.js wiring the help button) can drive it.
import { render } from 'preact';
import { useState, useEffect } from 'preact/hooks';

let setOpenExt = null;

export function openHelp() { if (setOpenExt) setOpenExt(true); }
export function closeHelp() { if (setOpenExt) setOpenExt(false); }

function Help() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpenExt = setOpen;
    return () => { setOpenExt = null; };
  }, []);

  if (!open) return null;
  const onBackdrop = (e) => { if (e.target === e.currentTarget) setOpen(false); };

  return (
    <div className="ach-modal show" role="dialog" aria-label="How to play" onClick={onBackdrop}>
      <div className="ach-card">
        <button className="ach-close" aria-label="Close" onClick={() => setOpen(false)}>×</button>
        <div className="ach-title">how this works</div>
        <div className="ach-sub">single-file idle clicker with too many mechanics. ☰ menu has tabs.</div>
        <div style={{ fontSize: '0.85rem', lineHeight: 1.7, padding: '4px' }}>
          <p><b>tap 🍞</b> to collect. spend in the treats shop on bakers (passive rate) and tap upgrades. tap value scales with your passive rate.</p>
          <p><b>combo</b> — fast taps (10 / 25 / 50 in a row) give ×2 / ×3 / ×5 bonuses. <b>crit</b> — 5% of taps deal ×10 with a gold ✦.</p>
          <p><b>chaos events</b> every 30-90s. live buffs/debuffs show as pills under the rate. 3+ buffs in a row → next is doubled.</p>
          <p><b>golden 🥯</b> spawns ~once a minute. tap within 9s for 3 minutes of rate plus a random buff (frenzy ×7, lucky ×3, etc).</p>
          <p><b>sourdough phases</b> 🥖 cycle every 30min — knead/rise/bake/cool/stale, each rewires global rules. countdown is in the header.</p>
          <p><b>achievements</b> 🏆 — each adds +1% rate. <b>stats</b> live in the same tab.</p>
          <p><b>ascend 👑</b> at 1B lifetime for crowns (sqrt L/1B). each crown +5% rate forever. spend in 🪙 shop on permanent upgrades.</p>
          <p><b>crumb trail 🍞</b> — a ripe crumb appears every hour real-time. spend on the pantheon.</p>
          <p><b>yeast garden 🌱</b> — 3×3 plots. plant 6 species (sourdough, hops, barley, tinyclaw, stardust, voidmold). real-time growth, neighbor pollination.</p>
          <p><b>pantheon 🏛️</b> (post-ascension) — slot 3 of 6 temperaments in heart/mind/belly slots. every temperament has a tradeoff.</p>
          <p><b>yeast market 📈</b> (post-1T lifetime) — 5 commodities, prices fluctuate. own a baker → its commodity runs hot.</p>
          <p><b>burnt crusts 🥵</b> (post-1B) — pests attach to bakers, drain rate. tap to pop for 110% of accumulated drain.</p>
          <p><b>bakery chips</b> at the bottom of the play area: tap = info, long-press = sell 1 for 50% refund.</p>
        </div>
      </div>
    </div>
  );
}

export function mountHelp(el) {
  render(<Help />, el);
}
